export default "__VITE_ASSET__2ce3bd07__"